import { createContext, useContext } from "react";
import { hasRole, type Role, type User } from "@/lib/types";

export interface AuthContextValue {
  user: User;
  /** Ends the session here and returns to the sign-in screen. */
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

/** The signed-in person. Only rendered inside the gate, so it is always there. */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth used outside <AuthGate>");
  return value;
}

/**
 * Whether the signed-in person may do something. For hiding and disabling only —
 * the server enforces every one of these, so a control shown by mistake is a
 * refused request, never an escalation.
 */
export function useCan(role: Role): boolean {
  return hasRole(useAuth().user, role);
}
